
































// Importing components
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseInputField from '@/ui/BaseInputField.vue';

export default {
    name: 'TheFormLogin',
    components: {
        BaseLoadingAnimation,
        BaseInputField,
    },
    props: {
        userData: {
            type: Object,
            required: true,
        },
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
    },
    data() {
        return {};
    },
    methods: {
        onSubmit() {
            this.$emit('submit');
        },
    },
};
